function Error() {
  return (
    <h2 className="subtitle has-text-centered is-fullwidth">
      Oh no something went wrong, the sadness...
      <span role="img" aria-label="sad-emoji">
        {' '}
        😞
      </span>
    </h2>
  )
}

export default Error